import {
  Box,
  Button,
  Table,
  Thead,
  Tbody,
  Tr,
  Th,
  TableContainer,
  Text,
  Flex,
  Select,
  Icon,
  Td,
  Menu,
  MenuButton,
  IconButton,
  MenuItem,
  MenuList,
  Spinner,
  Tooltip,
  Switch,
} from "@chakra-ui/react";
import { useEffect, useState } from "react";
import {
  FaCheck,
  FaExclamation,
  FaEye,
  FaFileExport,
  FaLink,
  FaPlay,
  FaTimes,
  FaTrash,
  FaReceipt,
  FaMoneyCheck,
} from "react-icons/fa";
import { FiPlus } from "react-icons/fi";
import { useNavigate } from "react-router-dom";
import { useRecoilState } from "recoil";
import moment from "moment";
import ModalTransferDetail from "./component/modalTransferDetail";
import { HamburgerIcon } from "@chakra-ui/icons";
import { toast } from "react-toastify";
import ModalDeleteConfirmation from "./component/modalDeleteConfirmation";
import { refreshGlobal } from "../../../atoms/refreshGlobal";
import {
  dateForAPI,
  dateForListWithHours,
} from "../../../constants/dataFormat";
import TransferApiNovo from "../../../services/transferApiNovo";
import { JWTToken } from "../../vendas/listaDeVendas/SalesList";
import jwt_decode from "jwt-decode";
import DateDropdown from "../../../defaultComponents/dateDropdown";
import { goToAddTransferSolicitationListNew, goToLogin } from "../../../routes/coordinator";
import { CNPJFormater, CPFFormater } from "../../../defaultFunctions/formaters";
import Pagination from "../../../defaultComponents/pagination";
import { baseURL } from "../../../services/api";
import md5 from "md5";
import ValueDropdown from "../../vendas/listaDeVendas/defaultComponent/valueDropdown";
import fileDownload from "js-file-download";
import { customColors } from "../../../atoms/customColors";
import TransferApiDireto from "../../../services/TransferApiDireto";
import ModalConfirmTransf from "./component/modalConfirmTransf";
import ModalConfirmPaymentCode from "./component/ModalConfirmPaymentCode";
import { useCookies } from "react-cookie";
import { selectedClientHeader } from "../../../atoms/selectedClientHeader";


let userFromLocalStorage: User = {
  id: 0,
  nome: "",
  email: "",
  ativo: false,
  idLoginTipo: 0,
  apiout: false,
  primeiroAcesso: false,
  expiracaoSenha: "",
  loginControle: {
    idLogin: 0,
    primeiroAcesso: false,
    expiracaoSenha: "",
  },
};

interface User {
  id: number;
  nome: string;
  email: string;
  ativo: boolean;
  idEmpresa?: number | null;
  idCliente?: number | null;
  idVendedor?: number | null;
  idProjeto?: number | null;
  idLoginTipo: number;
  apiout: boolean;
  primeiroAcesso: boolean;
  expiracaoSenha: string;
  idTipoGestor?: number | null;
  loginControle: {
    idLogin: number;
    primeiroAcesso: boolean;
    expiracaoSenha: string;
    celular?: string | null;
    tipo2FA?: string | null;
    isAtivo?: boolean | null;
    idTipoUsuario?: number | null;
  };
}

interface PaymentList {
  atualizadoEm: string;
  cliente: {
    ativo: boolean;
    cnpj: string;
    email: string;
    id: number;
    idPlano: number;
    idPromocao: number;
    isCnpj: boolean;
    nome: string;
    nomeFantasia: string;
    razaoSocial: string;
    sobrenome: string;
  };
  cnpjDestinatario: string;
  criadoEm: string;
  id: number;
  idCliente: number;
  idStatus: number;
  idTipoConta: number;
  nomeDestinatario: string;
  nroAgencia: string;
  nroAgenciaDigito: string;
  nroBanco: string;
  nroConta: string;
  nroContaDigito: string;
  observacao: string;
  status: {
    id: number;
    status: string;
  };
  tipoConta: any;
  transferenciaHistorico: [transferHistorico];
  valor: number;
  tipoPix: string;
  tipoChave: string;
  chavePix: string;
}

export interface transferHistorico {
  atualizadoEm: string;
  criadoEm: string;
  data: string;
  hora: string;
  id: number;
  idStatus: number;
  idTransferencia: number;
  observacao: string;
  status: any;
}

interface StatusTypes {
  [chave: string]: JSX.Element;
}

const statusTypes: StatusTypes = {
  Efetivado: <FaCheck />,
  Processando: <FaExclamation />,
  Pendente: <FaExclamation />,
  "Remessa Gerada": <FaExclamation />,
  "Não efetivado": <FaExclamation />,
  Cancelado: <FaTimes />,
  "Prazo excedido": <FaTimes />, // Added new status icon
};

export default function TransferSolicitatioNew() {
  const [search, setSearch] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize, setPageSize] = useState(15);
  const [pages, setPages] = useState(1);
  const [loading, setLoading] = useState(false);
  const [salesList, setSalesList] = useState(Array<PaymentList>);
  const [isOpen, setIsOpen] = useState(false);
  const [openDelete, setOpenDelete] = useState(false);
  const [isManual, setIsManual] = useState(false);
  const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
  const [selectedTransfer, setSelectedTransfer] = useState<PaymentList | null>(
    null
  );
  const colors = useRecoilState(customColors)[0];
  const refresh = useRecoilState(refreshGlobal)[0];
  const selectedId = useRecoilState(selectedClientHeader)[0]; //adicionei o id de cliente selecionado 
  const token = window.localStorage.getItem("token");
  let jwtToken: JWTToken = jwt_decode(token || "");
  const idDoUsuarioLogado = Number(jwtToken.idCliente);  
  const [paymentDetails, setPaymentDetails] = useState(
    Array<transferHistorico>
  );
  const initialValues = {
    clientFilter: 0,
    statusFilter: 0,
    saleTypeFilter: 0,
    initialDateFilter: moment().startOf("day").format(dateForAPI),
    finalDateFilter: moment().endOf("day").format(dateForAPI),
    minValueFilter: 0,
    maxValueFilter: 0,
  };
  const [filtros, setFiltros] = useState(initialValues);
  const [idTransfer, setIdTransfer] = useState(0);
  let dias =
    moment(filtros.finalDateFilter).diff(filtros.initialDateFilter, "days") >=
    32;
  const navigate = useNavigate();

  const userFromLocalStorageString = localStorage.getItem("user");
  let idCliente = 0;
  const [cookies] = useCookies();
  const userFromCookies = cookies.user;

  if (userFromLocalStorageString) {
    userFromLocalStorage = JSON.parse(userFromLocalStorageString);
    idCliente = userFromLocalStorage.id;
  } else if (userFromCookies) {
    userFromLocalStorage = JSON.parse(userFromCookies);
    idCliente = userFromCookies.id;
  } else if (token) {
    let jwtToken: JWTToken = jwt_decode(token || "");
    idCliente = Number(jwtToken.idCliente);
    userFromLocalStorage.email = jwtToken.email;
  } else {
    window.localStorage.removeItem("token");
    window.localStorage.removeItem("user");
    goToLogin(navigate);
    window.location.reload();
    console.error("User not found in localStorage or cookies");
    toast.error("Usuário não encontrado. Faça login novamente.");
  }

  async function getPaymentList() {
  try {
    setLoading(true);
    
    // var criada para definir id de busca
    const idParaBusca = selectedId === 0 ? idDoUsuarioLogado : selectedId;
    
    const response = await TransferApiNovo.getTransferSolicitation(
      filtros.statusFilter,
      idParaBusca,  // var de busca
      filtros.initialDateFilter,
      filtros.finalDateFilter,
      currentPage,
      pageSize,
      search,
      filtros.minValueFilter,
      filtros.maxValueFilter,
      isManual
    );
    console.log("API Response:", response.config.url);
    console.log("ID usado na busca:", idParaBusca); // debug
    setSalesList(response.data);
    setPages(
      Math.ceil(Number(response.headers.totalamountofrecords) / pageSize)
    );
    setLoading(false);
  } catch (error) {
    setLoading(false);
    console.log("error", error);
  }
}

  const onChangeSize = (e: any) => {
    setPageSize(e.target.value);
    setCurrentPage(1);
  };

  const FuncaoChamarRotaCancelar = async (idTransfer: number) => {
    try {
      const obj = {};
      const response = await TransferApiDireto.deleteTransferPerId(
        idTransfer,
        obj
      );
      console.log("Transferência cancelada com sucesso!", response);
      await getPaymentList();
    } catch (error) {
      console.error("Erro ao cancelar transferência:", error);
    }
  };

  async function Export() {
    try {
      setLoading(true);
      const response = await TransferApiNovo.exportTransferencia(
        filtros.statusFilter,
        filtros.minValueFilter,
        filtros.maxValueFilter,
        filtros.initialDateFilter,
        filtros.finalDateFilter,
        Number(jwtToken.idCliente),
        ""
      );
      fileDownload(response, "transferencias.xlsx");
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.error("Não foi possível exportar o arquivo!");
    }
  }

  useEffect(() => {
    if (currentPage > pages) {
      setCurrentPage(1);
      getPaymentList();
    }
  }, [pages]);

  useEffect(() => {
  getPaymentList();
}, [
  search,
  currentPage,
  pageSize,
  refresh,
  filtros.initialDateFilter,
  filtros.finalDateFilter,
  filtros.clientFilter,
  filtros.minValueFilter,
  filtros.maxValueFilter,
  filtros.statusFilter,
  isManual,
  selectedId,  // id selecionado
  idDoUsuarioLogado, 
]);

  const DataFilterOptions = [
    { key: 1, value: "Data de Envio", text: "Data de Envio" },
    { key: 2, value: "Data de Pagamentos", text: "Data de Pagamentos" },
    { key: 3, value: "Data de Agendamento", text: "Data de Agendamento" },
  ];

  const SituationFilterOptions = [
    { key: 1, value: "Pendente", text: "Pendente" },
    { key: 2, value: "Remessa Bancária", text: "Remessa Bancária" },
    { key: 3, value: "Em Processamento", text: "Em Processamento" },
    { key: 4, value: "Finalizado", text: "Finalizado" },
    { key: 5, value: "Cancelado", text: "Cancelado" },
    { key: 6, value: "Não Efetivado", text: "Não Efetivado" },
  ];

  const arrayDeStatus = [
    { id: 1, status: "Pendente" },
    { id: 2, status: "Remessa Gerada" },
    { id: 3, status: "Processando" },
    { id: 4, status: "Efetivado" },
    { id: 5, status: "Cancelado" },
    { id: 6, status: "Não Efetivado" },
  ];

  function onChangeStatusFilter(e: any) {
    setFiltros({ ...filtros, statusFilter: Number(e.target.value) });
  }

  const statusOptions =
    arrayDeStatus &&
    arrayDeStatus.map((item) => {
      return {
        key: item.id,
        value: item.id,
        text: item.status,
      };
    });

  const handleOpenConfirmModal = (transfer: PaymentList) => {
    setSelectedTransfer(transfer);
    setIsConfirmModalOpen(true);
  };

  const getTransferData = (transfer: PaymentList) => {
    return {
      id: transfer.id,
      tipoPix: transfer.tipoPix,
      tipoChave: transfer.tipoChave,
      chavePix: transfer.chavePix,
      idTipoConta: transfer.idTipoConta,
      nomeDestinatario: transfer.nomeDestinatario,
      cnpjDestinatario: transfer.cnpjDestinatario,
      observacao: transfer.observacao,
      nroBanco: transfer.nroBanco,
      nroAgencia: transfer.nroAgencia,
      nroAgenciaDigito: transfer.nroAgenciaDigito,
      nroConta: transfer.nroConta,
      nroContaDigito: transfer.nroContaDigito,
      valor: transfer.valor,
      dataTransferencia: moment().format("YYYY-MM-DDTHH:mm:ss.SSS"),
    };
  };

  const handleConfirmPayment = async () => {
    await getPaymentList(); // Refresh the list
  };

  // Function to check if transfer is expired (more than 1 day old)
  const isTransferExpired = (criadoEm: string) => {
    const createdDate = moment(criadoEm);
    const currentDate = moment("2025-05-22T09:16:00-03:00"); // Hardcoded for consistency with provided date
    const diffInDays = currentDate.diff(createdDate, "days");
    return diffInDays > 1;
  };

  return (
    <Flex flexDir={"column"} height="100%" width="100%" bgColor={colors.WHITE}>
      <Box
        width={"100%"}
        height={"fit-content"}
        mt={"0.3%"}
        mx="auto"
        py={3}
        px={3}
      >
        <Flex px={8} py={3} alignItems="center">
          <FaPlay color={colors.BLUEMONEDDBUTTONS} size="25px" />
          <Text
            mx={4}
            color={colors.BLUEMONEDDBUTTONS}
            fontSize={35}
            fontWeight={"bold"}
          >
            Transferências PIX
          </Text>
        </Flex>
      </Box>
      <Flex
        width={"100%"}
        height={"fit-content"}
        mt={"0.1%"}
        mx="auto"
        py={3}
        px={10}
        flexDirection={"column"}
      >
        <Text mb={2} fontWeight={"bold"}>
          Filtros
        </Text>
        <Flex width={"100%"} height={"100%"} justifyContent="space-evenly">
          <DateDropdown filtros={filtros} setFiltros={setFiltros} />
          <ValueDropdown filtros={filtros} setFiltros={setFiltros} />
          <Select
            fontSize={"0.8rem"}
            placeholder="Filtrar por Status"
            maxW={"14%"}
            value={filtros.statusFilter}
            onChange={onChangeStatusFilter}
          >
            {statusOptions.map((item) => (
              <option value={item.value} key={item.key}>
                {item.text}
              </option>
            ))}
          </Select>
          <Flex alignItems="center">
            <Switch
              isChecked={isManual}
              onChange={(e) => setIsManual(e.target.checked)}
              mr={2}
            />
            <Text fontSize={"0.8rem"}>Transferências Manuais</Text>
          </Flex>
          <Button
            bgColor={colors.GRAY_NEUTRAL}
            color={colors.WHITE}
            onClick={() => {
              setFiltros(initialValues);
              setIsManual(false);
            }}
          >
            Limpar Filtros
          </Button>
          <Button
            bg={"none"}
            color={colors.BLUEMONEDDBUTTONS}
            isDisabled={loading || dias}
            onClick={() => {
              Export();
            }}
            mx="10px"
            isLoading={loading}
            textTransform={"uppercase"}
            leftIcon={<FaFileExport />}
          >
            <Text fontSize={"0.8rem"}>Exportar</Text>
          </Button>
          <Button
            bgColor={colors.BLUEMONEDDBUTTONS}
            color={colors.WHITE}
            onClick={() => {
              goToAddTransferSolicitationListNew(navigate);
            }}
          >
            <Icon mr={2} as={FiPlus} />
            Nova Transferência
          </Button>
        </Flex>
      </Flex>

      {loading ? (
        <Flex
          width={"100%"}
          height={"80vh"}
          mt={"0.1%"}
          justifyContent={"center"}
          alignItems={"center"}
          mx="auto"
          py={3}
          px={10}
          overflowY="scroll"
        >
          <Spinner size={"lg"} color={colors.VARIANT} />
        </Flex>
      ) : (
        <Box
          width={"100%"}
          height={"80vh"}
          mt={"0.1%"}
          mx="auto"
          py={3}
          px={10}
          overflowY="scroll"
        >
          <TableContainer>
            <Table variant="striped" colorScheme="blue" size="sm">
              <Thead h="60px" position="sticky" top="0">
                <Tr>
                  <Th
                    w={"300px"}
                    borderRadius={"8px 0 0 8px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Data da Envio
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Destinatário
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    CPF/CNPJ do Destinatário
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Conta
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Valor a Pagar
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Observação
                  </Th>
                  <Th
                    w={"300px"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Situação
                  </Th>
                  <Th
                    w={"300px"}
                    borderRadius={"0 8px 8px 0"}
                    textAlign={"center"}
                    bgColor={colors.BLUEMONEDDBUTTONS}
                    color={colors.WHITE}
                  >
                    Opções
                  </Th>
                </Tr>
              </Thead>
              <Tbody>
                {salesList &&
                  salesList.map((item: any, index: any) => {
                    const isExpired =
                      item.status.status === "Pendente" &&
                      isTransferExpired(item.criadoEm);
                    const displayStatus = isExpired
                      ? "Prazo excedido"
                      : item.status.status;

                    return (
                      <Tr key={index} cursor="pointer" onClick={() => { }}>
                        <Td fontSize={"13px"} borderRadius={"8px 0px 0px 8px"}>
                          {moment(item.criadoEm).format(dateForListWithHours)}
                        </Td>
                        <Td fontSize={"13px"}>{item.nomeDestinatario}</Td>
                        <Td fontSize={"13px"}>
                          {item.cnpjDestinatario.includes("*")
                            ? item.cnpjDestinatario
                            : item.cnpjDestinatario.length === 14
                              ? CNPJFormater(item.cnpjDestinatario)
                              : CPFFormater(item.cnpjDestinatario)}
                        </Td>
                        <Td>
                          <Flex flexDirection={"column"}>
                            <Text>Titular: {item.nomeDestinatario}</Text>
                            <Text>
                              CNPJ:{" "}
                              {item.cnpjDestinatario.includes("*")
                                ? item.cnpjDestinatario
                                : item.cnpjDestinatario.length === 14
                                  ? CNPJFormater(item.cnpjDestinatario)
                                  : CPFFormater(item.cnpjDestinatario)}
                            </Text>
                            <Text>
                              <>Pix por {item.tipoPix}</>
                            </Text>
                            <Text>
                              {item.tipoPix === "CHAVE" && (
                                <>
                                  Tipo de Chave:{" "}
                                  {item.tipoChave === "EVP"
                                    ? "EVP (CHAVE ALEATÓRIA)"
                                    : item.tipoChave}
                                </>
                              )}
                            </Text>
                            <Text>{<>Banco: {item.nroBanco}</>}</Text>
                            <Text>
                              {item.tipoPix === "CHAVE" ? (
                                `Chave Pix: ${item.chavePix}`
                              ) : (
                                <>
                                  Agencia: {item.nroAgencia} - Conta:{" "}
                                  {item.nroContaDigito
                                    ? `${item.nroConta}-${item.nroContaDigito}`
                                    : item.nroConta}
                                </>
                              )}
                            </Text>
                            <Text>
                              {item.chave !== null ? (
                                <></>
                              ) : (
                                <>
                                  Banco: {item.nroBanco} -{" "}
                                  {item.idTipoConta === 1
                                    ? "Corrente"
                                    : "Poupança"}
                                </>
                              )}
                            </Text>
                          </Flex>
                        </Td>
                        <Td>
                          {item.valor.toLocaleString("pt-BR", {
                            style: "currency",
                            currency: "BRL",
                          })}
                        </Td>
                        <Td>{item.observacao || "N/A"}</Td>
                        <Td>
                          {item.status.status === "Não efetivado" ? (
                            <Tooltip
                              label={
                                item.transferenciasHistorico[
                                  item.transferenciasHistorico.length - 1
                                ].observacao
                              }
                              hasArrow
                              bg={colors.ORANGEMONEDD}
                              color="white"
                              placement="auto-start"
                            >
                              <Flex
                                alignItems={"center"}
                                justifyContent="flex-start"
                              >
                                {statusTypes[displayStatus] || (
                                  <FaExclamation />
                                )}
                                <Flex ml={4}>{displayStatus}</Flex>
                              </Flex>
                            </Tooltip>
                          ) : (
                            <Flex
                              alignItems={"center"}
                              justifyContent="flex-start"
                            >
                              {statusTypes[displayStatus] || <FaExclamation />}
                              <Flex ml={4}>{displayStatus}</Flex>
                            </Flex>
                          )}
                        </Td>
                        <Td borderRadius={"0px 8px 8px 0px"}>
                          <Menu>
                            <MenuButton
                              as={IconButton}
                              aria-label="Options"
                              icon={<HamburgerIcon />}
                              bgColor={colors.BLUEMONEDDBUTTONS}
                              color={colors.WHITE}
                              size={"sm"}
                            />
                            <MenuList>
                              {(item.status.status === "Pendente" ||
                                isExpired) && (
                                  <MenuItem
                                    icon={<FaTrash />}
                                    onClick={() => {
                                      setOpenDelete(true);
                                      setIdTransfer(item.id);
                                    }}
                                  >
                                    Cancelar Solicitação
                                  </MenuItem>
                                )}
                              <MenuItem
                                icon={<FaEye />}
                                onClick={() => {
                                  setIsOpen(true);
                                  setPaymentDetails(
                                    item.transferenciasHistorico
                                  );
                                }}
                              >
                                Visualizar Histórico
                              </MenuItem>
                              {item.idStatus === 4 && (
                                <MenuItem
                                  icon={<FaReceipt />}
                                  onClick={() => {
                                    window.open(
                                      `${baseURL}/Comprovante/Transferencia/${item.chave
                                      }?secret=${md5(item.id)}`,
                                      "_blank"
                                    );
                                  }}
                                >
                                  Visualizar Recibo
                                </MenuItem>
                              )}
                              {item.status.status === "Pendente" &&
                                !isExpired && (
                                  <MenuItem
                                    icon={<FaMoneyCheck />}
                                    onClick={() => handleOpenConfirmModal(item)}
                                  >
                                    Pagar
                                  </MenuItem>
                                )}
                            </MenuList>
                          </Menu>
                        </Td>
                      </Tr>
                    );
                  })}
              </Tbody>
            </Table>
          </TableContainer>
          <ModalTransferDetail
            isOpen={isOpen}
            setIsOpen={setIsOpen}
            item={paymentDetails}
          />
          <ModalDeleteConfirmation
            isOpen={openDelete}
            setIsOpen={setOpenDelete}
            getTransferList={getPaymentList}
            id={idTransfer}
          />
          <ModalConfirmPaymentCode
            isOpen={isConfirmModalOpen}
            setIsOpen={setIsConfirmModalOpen}
            transferId={selectedTransfer?.id || 0}
            valor={selectedTransfer?.valor || 0}
            tipoChave={selectedTransfer?.tipoChave || ""}
            email={userFromLocalStorage.email}
            onConfirm={handleConfirmPayment}
          />
          <Flex width={"100%"} justifyContent="center" mt={8}>
            <Pagination
              currentPage={currentPage}
              setCurrentPage={setCurrentPage}
              pages={pages}
              pageSize={pageSize}
            />
            <Select
              value={pageSize}
              onChange={onChangeSize}
              size="sm"
              ml={5}
              maxW="70px"
              borderRadius="6px"
            >
              <option value={5}>5</option>
              <option value={10}>10</option>
              <option value={15}>15</option>
              <option value={25}>25</option>
            </Select>
          </Flex>
        </Box>
      )}
    </Flex>
  );
}
